import { render, staticRenderFns } from "./BatchUpdateForm.vue?vue&type=template&id=6ab694c0&"
import script from "./BatchUpdateForm.vue?vue&type=script&lang=js&"
export * from "./BatchUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports